<template>
    <div>
      <!-- main-area -->
      <main class="fix">
        <!-- breadcrumb-area -->
        <section class="breadcrumb__area breadcrumb__bg">
          <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="breadcrumb__content">
                  <h2 class="title">Anggota Fraksi</h2>
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a href="javascript:void(0);">Fraksi</a></li>
                      <li class="breadcrumb-item active" aria-current="page">Fraksi - Fraksi</li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <div class="breadcrumb__shape">
            <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
            <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
            <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
            <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
            <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
          </div>
        </section>
  
        <section class="services__details-area">
                <div class="container">
                    <div class="services__details-wrap">
                        <div class="row">
                            <div class="col-70 order-0 order-lg-2">
                              <div class="row" v-if="anggotaFraksiTerurut.length > 0">
                                <div class="col-md-3 col-sm-6 mb-4" v-for="d in anggotaFraksiTerurut" :key="d.id">
                                      <div class="team__item-two text-center">
                                        <div
                                          class="team__thumb-two shine-animate"
                                          @click="selectData(d)"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalFraksi"
                                          style="cursor: pointer;"
                                        >
                                          <img :src="getFoto(d)" alt="Foto Anggota Fraksi" @error="$event.target.src='assets/img/user.png'" />
                                        </div>
                                        <div class="team__content-two">
                                          <h5 class="title">{{ d.nama }}</h5>
                                          <span>{{ d.jabatan_fraksi }}</span>
                                         
                                        </div>
                                      </div>
                                    </div>
                               </div>
                              <div v-else class="text-center py-5">
                                <p class="text-muted fs-5">Belum ada anggota fraksi yang terdaftar untuk fraksi/periode ini.</p>
                              </div>
                            </div>
                            <div class="col-30">
                                <aside class="services__sidebar">
                                    <div class="sidebar__widget sidebar__widget-two">
                                      <div class="mb-3">
                                          <label for="filterMasaJabatan" class="form-label fw-bold">Pilih Masa Jabatan:</label>
                                          <select
                                            id="filterMasaJabatan"
                                            class="form-select"
                                            v-model="masa_jabatan_selected"
                                            @change="onChangeMasaJabatan"
                                          >
                                            <option
                                              v-for="m in list_masa_jabatan"
                                              :key="m.id"
                                              :value="m.id"
                                            >
                                              {{ m.label }}
                                            </option>
                                          </select>
                                        </div>
                                        <div class="sidebar__cat-list-two">
                                            <ul class="list-wrap" v-if="list_data_fraksi.length > 0">
                                              <li v-for="d in list_data_fraksi" :key="d.id" :class="{ active: fraksi_id_selected === d.id }">
                                                <a href="javascript:void(0)" @click="filterByFraksi(d.id)">
                                                  {{ d.nama }}
                                                  <i v-if="fraksi_id_selected === d.id" class="bi bi-check-circle-fill ms-2"></i>
                                                </a>
                                              </li>
                                            </ul>
                                            <div v-else class="py-3 text-center">
                                              <small class="text-muted">Belum ada fraksi pada periode ini.</small>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    
                                    
                                    
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
      </main>
    </div>

    <!-- Modal Detail Dewan -->
     <!-- Modal Detail Dewan -->
     <div class="modal fade" id="modalFraksi" tabindex="-1" aria-labelledby="dewanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content shadow-lg">
      <div class="modal-header text-white">
        <h5 class="modal-title" id="dewanModalLabel">{{ form.nama }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <!-- Foto -->
          <div class="col-md-5 text-center mb-3 mb-md-0">
            <img :src="getFoto(form)" alt="Foto Detail" class="img-fluid rounded shadow-sm" style="max-height: 300px; object-fit: cover;" @error="$event.target.src='assets/img/user.png'" />
          </div>

          <!-- Info Detail -->
          <div class="col-md-7">
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between">
                <strong>Jabatan DPRD:</strong>
                <span>{{ form.jabatan_dprd }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Jabatan Fraksi:</strong>
                <span>{{ form.jabatan_fraksi }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Daerah Pemilihan:</strong>
                <span>{{ form.dapil }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Tempat, Tanggal Lahir:</strong>
                <span>{{ form.ttl }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Agama:</strong>
                <span>{{ form.agama }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Alamat:</strong>
                <span>{{ form.alamat }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Partai:</strong>
                <span>{{ form.nama_partai }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>






  </template>
  
  <script>
  export default {
    data() {
      return {
        form : {
                id : '',
                nama : '',
                dapil : '',
                jabatan_dprd : '',
                jabatan_fraksi : '',
                uraian : '',
                foto : '',
                unit_kerja : '',
                status : '',
                keterangan : '',
            },
        fraksi_id_selected: "",
        list_data: [],
        list_data_fraksi: [],
        page_first: 1,
        page_last: 0,
        perPage: 12,
        masa_jabatan: "",
        selectedDewan: null,
  
        cari_value: "",
        file_path: this.$store.state.URL_APP + "uploads/",
        masa_jabatan_selected: "",
        list_masa_jabatan: [],
      };
    },
  
    computed: {
      
      anggotaFraksiTerurut() {
    const prioritas = {
      "Ketua Fraksi": 1,
      "Wakil Ketua Fraksi": 2,
      "Sekretaris Fraksi": 3,
    };

    return [...this.list_data].sort((a, b) => {
      const ja = (a.jabatan_fraksi || "").trim();
      const jb = (b.jabatan_fraksi || "").trim();

      const pa = prioritas[ja] || 4;
      const pb = prioritas[jb] || 4;

      return pa - pb;
    });
  }
    },
  
    methods: {

      filterByFraksi(id) {
        this.fraksi_id_selected = id;
        this.getAnggotaFraksi(id);
      },

      openModal(data) {
        if (!data) {
          console.warn("Data tidak tersedia");
          return;
        }
        this.selectData(data);
      },

        getFoto(item) {
        if (!item || !item.file) {
            return 'assets/img/user.png'; 
        }
        return this.file_path + item.file;
        },

        getListFraksi() {
          fetch(this.$store.state.ADD_URL_FRAKSI + "view", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ 
              data_ke: 0, 
              cari_value: "", 
              masa_jabatan: this.masa_jabatan_selected 
            }),
          })
            .then((res) => res.json())
            .then((res_data) => {
              this.list_data_fraksi = Array.isArray(res_data.data)
                ? res_data.data
                : (Array.isArray(res_data) ? res_data : []);

              if (this.list_data_fraksi.length > 0) {
                this.fraksi_id_selected = this.list_data_fraksi[0].id;
                this.getAnggotaFraksi(this.fraksi_id_selected);
              } else {
                this.fraksi_id_selected = "";
                this.list_data = [];
              }
            })
            .catch((err) => {
              console.error("Gagal ambil data fraksi:", err);
              this.list_data_fraksi = [];
              this.list_data = [];
            });
        },


        getAnggotaFraksi(id_fraksi) {
          if (!id_fraksi) {
            this.list_data = [];
            return;
          }
          fetch(this.$store.state.ADD_URL_FRAKSI + "view_fraksi", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              fraksi_id: id_fraksi,
              masa_jabatan: this.masa_jabatan_selected,
            }),
          })
            .then((res) => res.json())
            .then((res_data) => {
              const data = Array.isArray(res_data) ? res_data : (res_data.data || []);
              this.list_data = data;
            })
            .catch((err) => {
              console.error("Gagal ambil anggota fraksi:", err);
              this.list_data = [];
            });
        },



      getView() {
        fetch(this.$store.state.ADD_URL_DEWAN + "view", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            data_ke: this.page_first,
            cari_value: this.cari_value,
            masa_jabatan: this.masa_jabatan_selected,
            fraksi_id: this.fraksi_id_selected 
          }),
        })
        .then((res) => res.json())
        .then((res_data) => {
          this.list_data = res_data.data || [];
  
          const total = res_data.total_data || 0;
          const per_page = res_data.per_page || 12;
          this.page_last = Math.ceil(total / per_page) || 1;
        })
        .catch((err) => {
          console.error("Gagal ambil data:", err);
        });
      },
  
      getMasaJabatan() {
        fetch(this.$store.state.ADD_URL_MASA_JABATAN + "view", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data_ke: 1 }),
        })
        .then((res) => res.json())
        .then((res_data) => {
          this.list_masa_jabatan = res_data.data || [];
          const masaDefault = this.list_masa_jabatan.find(masa => masa.label === "2024 - 2029") || this.list_masa_jabatan[0];
          if (masaDefault) {
            this.masa_jabatan_selected = masaDefault.id;
          }
           
          this.getListFraksi(); 
        })
        .catch((err) => {
          console.error("Gagal ambil masa jabatan:", err);
        });
      },

      selectData: function(data) {
            this.form = {
              id: data.id,
              nama: data.nama,
              jabatan_dprd: data.jabatan_dprd,
              jabatan_fraksi: data.jabatan_fraksi || '', 
              ttl: data.ttl,
              partai: data.partai,
              dapil: data.dapil,
              agama: data.agama,
              alamat: data.alamat,
              nama_partai: data.nama_partai,
              file: data.file,
            };
        },
  
      btn_prev() {
        if (this.page_first > 1) {
          this.page_first--;
          this.getView();
        }
      },
      btn_next() {
        if (this.page_first < this.page_last) {
          this.page_first++;
          this.getView();
        }
      },
      go_to_page(page) {
        if (page !== "...") {
          this.page_first = page;
          this.getView();
        }
      },
      onChangeFilter(event) {
        const selectedId = event.target.value;
        this.masa_jabatan_selected = selectedId;
        this.fraksi_id_selected = "";
        this.getListFraksi();
      },

      onChangeMasaJabatan() {
        this.getListFraksi();
      }
    },
  
    mounted() {
     
      this.getMasaJabatan();
    }
  };
  </script>
  